import { connect } from '@vfde-sails/core';
import * as mapDispatch from 'Container/App/action';
import { TariffHtmlId } from '../../enums/elementId';
import { selectors as mapStateToProps } from 'Container/App/selector';
import { mountOptionPicker, updateTariffOptionPicker } from '../../components/optionPicker';
import { mountVerticalList, updateTariffBenefits } from '../../components/verticalList';
import { showElement } from '../../util/visibility';
import { mountHorizontalList, updateTariffLinks } from '../../components/horizontalList';
import { getUpdateFlags } from './update';

export type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

function container (_: State, actions: Actions) {
    const tariffOptionPicker = mountOptionPicker(TariffHtmlId.TARIFF_PICKER, (value: string) =>
        actions.setSelectedTariffId(value));
    const tariffBenefits = mountVerticalList(TariffHtmlId.BENEFITS_LIST);
    const tariffLinks = mountHorizontalList(TariffHtmlId.LINKS_LIST);

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const {
                tariffs,
                avcResult,
                selected,
                isContentEnabled,
            } = newState;

            const update = getUpdateFlags(newState, oldState);

            if (update.tariffChanged) {
                // Note: Tariff picker
                updateTariffOptionPicker(
                    isContentEnabled,
                    tariffOptionPicker,
                    tariffs,
                    avcResult?.metacodes,
                    selected.tariffId,
                );

                // Note: Tariff benefits
                updateTariffBenefits(tariffBenefits, selected.tariffId, avcResult);
                updateTariffLinks(tariffLinks, selected.tariff);
                showElement(TariffHtmlId.BENEFITS, isContentEnabled);
            }
        },
    };
}

const Container = connect(mapStateToProps, mapDispatch)(container);

export default Container;
